import RichText from '@/components/atoms/rich-text/rich-text';
import Column from '@/components/utilities/column/column';
import Row from '@/components/utilities/row/row';
import TravelPlanTable from './travel-plan-table/travel-plan-table';
import styles from './travel-plan.module.scss';

export interface TravelPlanProps {
  /** The travel plan information to show */
  travelPlan?: Content.Components['TravelPlanModuleDto']['travelPlan'];
}

const TravelPlan = ({ travelPlan }: TravelPlanProps) => {
  if (!travelPlan) return null;

  return (
    <div className={styles.component}>
      {travelPlan.$type === 'TravelPlanPlaneDto' && (
        <Row className={styles.tablesRow}>
          {'outboundTable' in travelPlan && (
            <Column width={{ tablet: 6 }}>
              <TravelPlanTable
                {...travelPlan.outboundTable}
                icon="PlaneTakeOff"
              />
            </Column>
          )}

          {'homeboundTable' in travelPlan && (
            <Column width={{ tablet: 6 }}>
              <TravelPlanTable
                {...travelPlan.homeboundTable}
                icon="PlaneLanding"
              />
            </Column>
          )}
        </Row>
      )}

      {travelPlan.$type === 'TravelPlanBusDto' && 'table' in travelPlan && (
        <Row className={styles.tablesRow}>
          <Column width={{ laptop: 8 }}>
            <TravelPlanTable {...travelPlan.table} icon="Bus" />
          </Column>
        </Row>
      )}

      {travelPlan.$type === 'TravelPlanTrainDto' && 'table' in travelPlan && (
        <Row className={styles.tablesRow}>
          <Column width={{ laptop: 8 }}>
            <TravelPlanTable {...travelPlan.table} icon="Train" />
          </Column>
        </Row>
      )}

      {'customerInformation' in travelPlan &&
        travelPlan.customerInformation.length > 0 && (
          <Row className={styles.descriptionsRow}>
            {travelPlan.customerInformation.map((item, itemIndex) => (
              <Column
                key={itemIndex}
                className={styles.contentColumn}
                width={{ tablet: 6 }}
              >
                <RichText text={item} />
              </Column>
            ))}
          </Row>
        )}
    </div>
  );
};

TravelPlan.displayName = 'TravelPlan';

export default TravelPlan;
